<script>
    // https://svelte.dev/repl/253993c0325a4b1b8ff38b4c4ecd2285?version=3.24.1

    import { clickOutside } from "../utils/clickOutside.js";

    export let styleGroup;
    export let styleInput;
    export let styleDropdown;

    export let key;
    export let settings;
    export let placeholder;

    export let datalistPopulationCallback; // has to return an array
    export let datalistSelectionCallback;
    export let onEnterCallback;

    let options = [];

    let showOptions = false;
    let error = "";

    let element;
    let value = "";
    let activeItemIndex = 0;

    let isSearching = false;

    function debounce(callback, delay) {
        let timeout;

        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                callback(...args);
            }, delay);
        };
    }

    const populateOptions = debounce(async () => {
        options = [];

        isSearching = true;

        showOptions = true;

        let data = await datalistPopulationCallback(value);

        isSearching = false;

        options = formatData(data);
    }, 300);

    function formatData(data) {
        return data?.map((item) => {
            let values = [];

            settings.optionValueFormat.forEach((format) => {
                values.push({
                    text: item[format.key],
                    width: format.width,
                });
            });

            return {
                key: item[settings.keyFormat]?.trim(),
                values: values,
                img: item.img,
            };
        });
    }

    $: {
        if (!value) {
            options = [];
            showOptions = false;
        }
    }

    $: key = options && options.length > 0 ? options[activeItemIndex].key : 0;

    let dropdown;

    const refs = [];

    let isSelecting;

    function handleKeydown(e) {
        let keyboardKey = e.key;

        if (keyboardKey !== "ArrowUp" && keyboardKey !== "ArrowDown") return;

        isSelecting = true;

        e.preventDefault(); // prevent caret movin to start on arrow up

        activeItemIndex += keyboardKey === "ArrowDown" ? 1 : -1;

        if (activeItemIndex > options.length - 1) activeItemIndex = 0;
        if (activeItemIndex < 0) activeItemIndex = options.length - 1;

        refs[activeItemIndex].scrollIntoViewIfNeeded();
    }

    function clear() {
        if (settings.clearAfterSelection) {
            value = null;
            key = null;
        }

        showOptions = false;

        activeItemIndex = 0;
        options = [];
        element.focus;
    }
</script>

<svelte:window on:keydown={handleKeydown} />

<div class="container" style={styleGroup}>
    <div class="field">
        <input
            bind:this={element}
            bind:value
            {placeholder}
            on:click={() => {
                element.setSelectionRange(0, value?.length);
                showOptions = !showOptions;
            }}
            on:input={populateOptions}
            on:keydown={(e) => {
                if (e.key != "Enter") return;
                if (isSelecting) {
                    datalistSelectionCallback(key);
                    clear();
                } else {
                    onEnterCallback(value);
                    clear();
                }
                clear();
            }}
            style={styleInput}
            name="datalist"
            autocomplete="off"
        />
        <i class="fas fa-caret-down" />
    </div>

    {#if showOptions}
        <div
            bind:this={dropdown}
            class="options"
            use:clickOutside
            on:click-outside={() => {
                showOptions = false; // <------------------------------------- radi ova ne se zatvara dropdown na input click
            }}
            style={styleDropdown}
        >
            {#if options && options.length > 0}
                <div class="headers">
                    {#each settings.headers as header}
                        <div class="header" style={`width: ${header.width}px;`}>
                            {header.text}
                        </div>
                    {/each}
                </div>
            {/if}

            <div class="body">
                {#if options && options.length > 0}
                    {#each options as option, i}
                        <div
                            class="option"
                            bind:this={refs[i]}
                            class:selected={i == activeItemIndex}
                            on:click={() => {
                                datalistSelectionCallback(option.key);
                                clear();
                            }}
                        >
                            <!-- {#if settings.image} -->
                            <img
                                src={option.img}
                                style={`width: ${settings.image.width}px;`}
                            />
                            <!-- {/if} -->
                            {#each option.values as value}
                                <div
                                    class="value"
                                    style={`width: ${value.width}px;`}
                                >
                                    {value.text}
                                </div>
                            {/each}
                        </div>
                    {/each}
                {:else if value}
                    <div style="padding: 20px; opacity: 0.5;">
                        {#if isSearching}
                            Pretraživanje...
                        {:else}
                            Nema podataka...
                        {/if}
                    </div>
                {/if}
            </div>
        </div>
    {/if}

    {#if error}
        <div class="error">{error}</div>
    {/if}
</div>

<style>
    .container {
        position: relative;
    }

    .field i {
        margin-left: -25px;
    }

    input {
        width: 220px;
    }

    .error {
        font-size: 16px;
        color: red;
        margin-top: 5px;
    }

    .headers {
        display: flex;
        align-items: center;
    }

    .header {
        margin-right: 10px;
        padding: 5px;
        font-weight: bold;
    }

    .body {
        overflow: auto;
    }

    .options {
        max-height: 300px;
        width: 800px;
        position: absolute;
        display: flex;
        flex-direction: column;
        background: white;
        z-index: 1;
        border-radius: 5px;
        margin-top: 3px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        scroll-behavior: smooth;
    }

    .option {
        cursor: pointer;
        padding: 5px;
        margin-bottom: 3px;
        display: flex;
    }

    /* .option:focus {
        background: green;
    } */

    .option:hover {
        background: #eee;
    }

    .value {
        margin-right: 10px;
    }

    .selected {
        background: #ccc;
    }

    img {
        width: 25px;
        height: 25px;
        margin-right: 10px;
    }
</style>
